import React, { useState, useEffect, Fragment } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import axios from "axios";
import toast from "react-hot-toast";
import Modal from "react-bootstrap/Modal";
import $ from "jquery";

import exp from "../static/images/Experiencia_Laboral.png";
import addbutton from "../static/images/add-button.png";
import moment from "moment";
import { es_locale } from "../utils/Moment/es_local";

const months = {
  1: "Enero",
  2: "Febrero",
  3: "Marzo",
  4: "Abril",
  5: "Mayo",
  6: "Junio",
  7: "Julio",
  8: "Agosto",
  9: "Septiembre",
  10: "Octubre",
  11: "Noviembre",
  12: "Diciembre",
};

function Experiencia({ data, edit }) {
  const [mesArr] = useState([]);
  const [yearArr] = useState([]);
  const [experiencia, setExperiencia] = useState([]);
  const [listCompany, setlistCompany] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expUpdate, setexpUpdate] = useState("");
  const [flagUpdate, setflagUpdate] = useState(false);
  const [deleteExp, setdeleteExp] = useState("");
  const [show, setShow] = useState(false);
  const [actualJob, setactualJob] = useState(false);

  const [addCompany, setaddCompany] = useState("");
  const [areaList, setareaList] = useState([]);
  const [otraEmpresa, setOtraEmpresa] = useState(false);

  const handleClose = () => setShow(false);

  moment.locale("es", es_locale);

  useEffect(() => {
    const getArea = () => {
      axios.get("access/areas").then((result) => {
        if (result.status === 200) {
          setareaList(result.data);
        } else if (result.status === 400) {
          toast.error(
            result.errors[0].field + " " + result.errors[0].defaultMessage
          );
        } else toast.error(result.message);
      });
    };

    if (data === undefined) {
      setLoading(true);
    } else {
      fillDate();
      GetExperience();
      GetListCompany();
      getArea();
    }

    //eslint-disable-next-line
  }, [data]);

  function convertoArray(item) {
    let array = [];

    for (var p in item) {
      if (item.hasOwnProperty(p)) {
        let rol = { value: "", desc: "" };
        rol.value = item[p].companyId;
        rol.desc = item[p].name;

        array.push(rol);
      }
    }
    setlistCompany(array);
  }

  function fillDate() {
    for (var i = 1; i <= 12; i++) {
      let mes = { value: "", desc: "" };

      mes.value = i;
      mes.desc = i;
      mesArr.push(mes);
    }

    let currentYear = new Date().getFullYear();
    let earliestYear = 1970;

    while (currentYear >= earliestYear) {
      let year = { value: "", desc: "" };

      year.value = currentYear.toString();
      year.desc = currentYear.toString();
      yearArr.push(year);
      currentYear -= 1;
    }
  }

  function GetListCompany() {
    axios.get("access/list-company").then((result) => {
      convertoArray(result.data);
      setLoading(false);
    });
  }

  function GetExperience() {
    axios.get("experience/list-experience-applicant/" + data).then((result) => {
      setExperiencia(result.data);
      setLoading(false);
    });
  }

  function GuardarExperiencia(values, resetForm = () => {}) {
    const startDate = new Date(values.anoInicio, values.mesInicio - 1);
    const endDate = new Date(values.anoFin, values.mesFin - 1);

    //validar que la fecha de inicio sea mayor que la fecha de fin
    if (!actualJob) {
      if (endDate < startDate) {
        toast.error("Las fechas son inválidas, favor verifique!", {
          duration: 5000,
        });
        return;
      }
    }

    let exp = {
      ...values,
      applicantExperienceId: 0,
      applicantId: data,
      companyId: values.addCompany,
      currentJob: values.currentJob,
      jobDateEnd: endDate,
      jobDateInit: startDate,
      areaId: parseInt(values.areaId),
    };

    if (parseInt(values.addCompany) === -1) {
      exp.companyId = null;
    } else {
      exp.otraEmpresa = "";
    }

    axios
      .post("experience/create-applicantexperience", exp)
      .then((result) => {
        if (result.status === 200) {
          toast.success(result.data.message, {
            duration: 4000,
          });
          //GetExperience();
          $("#agregar-experiencia-modal").modal("hide");
          setactualJob(false);
          resetForm(true);
        }
      })
      .catch(function (error) {
        $("#agregar-experiencia-modal").modal("hide");
      })
      .finally(() => setOtraEmpresa(false));
  }

  function UpdateExperiencia(values) {
    const startDate = new Date(values.anoInicio, values.mesInicio - 1);
    const endDate = new Date(values.anoFin, values.mesFin - 1);

    //validar que la fecha de inicio sea mayor que la fecha de fin
    if (!actualJob) {
      if (endDate < startDate) {
        toast.error("Las fechas son inválidas, favor verifique!", {
          duration: 5000,
        });
        return;
      }
    }

    let exp = {
      ...values,
      applicantExperienceId: expUpdate.positionId,
      applicantId: expUpdate.applicantProfileId,
      jobDateEnd: endDate,
      jobDateInit: startDate
    };

    if(parseInt(exp.companyId) === -1) {
      exp.companyId = null
    } else {
      exp.otraEmpresa = ""
      exp.companyId = parseInt(exp.companyId)
    }
    

    axios.post("experience/update-applicantexperience", exp).then((result) => {
      if (result.status === 200) {
        toast.success(result.data.message, {
          duration: 4000,
        });
        $("#editar-experiencia-modal").modal("hide");
        GetExperience();
      }
    });
  }

  function SearchExperiencia(id) {
    let exp = experiencia.find((item) => parseInt(item.positionId) === parseInt(id))

    if (exp === undefined) {
      return
    }

    setexpUpdate(exp)
    setactualJob(exp.currentlyJob)
    setOtraEmpresa(exp.companyId === null)
  }

  function showOtraEmprea(e, id) {
    setaddCompany(e.target.value);
    const inp = document.getElementById(id);
    if (e.target.value === "0") {
      inp.style.setProperty("display", "");
    } else inp.style.setProperty("display", "none");
  }

  const pp = { maxWidgt: "78px", maxHeight: "74px" };

  const Validaciones = Yup.object().shape({
    position: Yup.string()
      .required("No puede estar vacio")
      .max(60, "No puede tener mas de 60 caracteres"),
    description: Yup.string()
      //.required("No puede estar vacio")
      .max(250, "No puede tener mas de 250 caracteres"),
    mesInicio: Yup.number()
      .required("No puede estar vacio")
      .integer("Tiene que ser un numero entero"),
    anoInicio: Yup.number()
      .required("No puede estar vacio")
      .integer("Tiene que ser un numero entero"),
    mesFin: Yup.number()
      .required("No puede estar vacio")
      .integer("Tiene que ser un numero entero"),
    anoFin: Yup.number()
      .required("No puede estar vacio")
      .integer("Tiene que ser un numero entero"),
    areaId: Yup.number().required("Seleccione un area"),
    ...(otraEmpresa
      ? {
          otraEmpresa: Yup.string.apply().required("Escriba la otra empresa"),
        }
      : {}),
  });

  function modalDelete() {
    setdeleteExp(expUpdate.positionId);
    setShow(true);
  }

  function DeleteExperiencia() {
    const exp = {
      applicantExperienceId: deleteExp,
      applicantId: 0,
      companyId: 0,
      currentJob: true,
      description: "string",
      jobDateEnd: "2021-03-26T17:39:14.687Z",
      jobDateInit: "2021-03-26T17:39:14.687Z",
      position: "string",
    };

    axios
      .post("experience/delete-applicantexperience", exp)
      .then((result) => {
        if (result.status === 200) {
          setShow(false);
          toast.success(result.data.message, {
            duration: 4000,
          });
          GetExperience();
          setactualJob(false);
          $("#editar-experiencia-modal").modal("hide");
        }
      })
      .catch(function (error) {
        $("#editar-experiencia-modal").modal("hide");
      });
  }

  function inHabilitarFechaFin() {
    setactualJob(!actualJob);
  }

  if (loading) {
    return <div className="loader_component"></div>;
  }

  return (
    <Fragment>
      <div>
        <div className="box left-col">
          <div className="head">
            <div className="title">Experiencia</div>
            {edit && (
              <button
                data-bs-toggle="modal"
                style={{ border: "none" }}
                data-bs-target="#agregar-experiencia-modal"
                data-title="Experiencia"
              >
                <img src={addbutton} alt="Agregar Experiencia"></img>
              </button>
            )}
          </div>

          <List {...{experiencia, pp, edit, SearchExperiencia}} />
        </div>
      </div>

      {edit && (
        <>
          {/* Agregar */}
          <ModalAdd {...{
            setactualJob, 
            GuardarExperiencia, 
            Validaciones, 
            setOtraEmpresa, 
            listCompany, 
            otraEmpresa, 
            areaList, 
            mesArr, 
            yearArr, 
            actualJob, 
            inHabilitarFechaFin
          }} />
          

          {/* Editar */}
          <ModalEdit {...{
            setactualJob, 
            expUpdate, 
            UpdateExperiencia, 
            Validaciones, 
            showOtraEmprea, 
            listCompany, 
            areaList, 
            mesArr, 
            yearArr, 
            actualJob, 
            inHabilitarFechaFin, 
            modalDelete,
            otraEmpresa,
            setOtraEmpresa
          }} />

          {/* Eliminar */}
          <Modal
            show={show}
            keyboard={false}
            dialogClassName="kr-modal"
            onHide={handleClose}
          >
            <Modal.Body>
              <div className="form form--white ">
                <div className="div__wrapper">
                  <div className="form__title text-center">
                    Eliminar Experiencia
                  </div>
                  <div className="form__row">
                    <div className="col-sm-12 ">
                      <label htmlFor="names">
                        Desea eliminar este registro?
                      </label>
                    </div>
                  </div>
                  <div className="form__row">
                    <button
                      className="btn btn--gradient btn__icon btn__icon--door"
                      onClick={() => DeleteExperiencia()}
                    >
                      Eliminar
                    </button>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </>
      )}
    </Fragment>
  );
}

function List({experiencia, pp, edit, SearchExperiencia}) {
  return (
    <>
      {experiencia.map((item, index) => {
        return (
          <div key={index} className="company">
            <div className="company__wrapper">
              <div className="logo">
                <img
                  alt={"expirience" + index}
                  src={
                    item.profileImagePath !== undefined &&
                    item.profileImagePath !== null &&
                    item.profileImagePath !== "" &&
                    item.profileImagePath !== "MQ=="
                      ? item.profileImagePath
                      : exp
                  }
                  style={pp}
                ></img>
              </div>
              <div className="content">
                <div className="asistente">{item.position}</div>
                <div className="name">{item.nameCompany}</div>
                <div className="date">
                  {moment(item.dateInit, "YYYY-MM-DD").format("MMMM-YYYY") +
                    " / " +
                    (item.currentlyJob
                      ? "Actualmente"
                      : moment(item.dateEnd, "YYYY-MM-DD").format("MMMM-YYYY"))}
                  <span></span>
                </div>
              </div>
            </div>
            <div
              id={"descripcion-experiencia-" + item.positionId}
              className="collapse company__bio"
            >
              {item.description}
            </div>
            <div className="toolset">
              {edit && (
                <button
                  href="#"
                  className="edit-button"
                  data-bs-toggle="modal"
                  data-bs-target="#editar-experiencia-modal"
                  data-title="Experiencia"
                  onClick={() => SearchExperiencia(item.positionId)}
                ></button>
              )}
              <button
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={"#descripcion-experiencia-" + item.positionId}
                aria-expanded="false"
                aria-controls="job-description-1"
                className="view-more"
              >
                Ver Más <i className="fas fa-chevron-down"></i>
              </button>
            </div>
          </div>
        );
      })}
    </>
  );
}

function ModalAdd({setactualJob, GuardarExperiencia, Validaciones, setOtraEmpresa, listCompany, otraEmpresa, areaList, mesArr, yearArr, actualJob, inHabilitarFechaFin}) {

  return (
    <>
      <div
        id="agregar-experiencia-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>

              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
                onClick={() => setactualJob(false)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <Formik
                initialValues={{
                  position: "",
                  addCompany: "",
                  mesInicio: 1,
                  anoInicio: 2021,
                  mesFin: 1,
                  anoFin: 2021,
                  currentJob: false,
                  description: "",
                  areaId: 0,
                  otraEmpresa: "",
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  setSubmitting(true);
                  GuardarExperiencia(values, resetForm);
                  setSubmitting(false);
                }}
                validationSchema={Validaciones}
              >
                {({ errors, touched, isSubmitting, handleChange }) => (
                  <Form>
                    <div className="mb-4 row">
                      <label htmlFor="cargo" className="col-sm-2 pe-0">
                        Cargo
                      </label>
                      <div className="col-sm-10">
                        <Field
                          id="position"
                          name="position"
                          type="text"
                          required
                          className="form-control form-control-sm"
                        ></Field>
                        {errors.position && touched.position && (
                          <span className="form__validation form__validation--error">
                            {errors.position}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="mb-4 row">
                      <label htmlFor="empresa" className="col-sm-2 pe-0">
                        Empresa
                      </label>
                      <div className="col-sm-10">
                        <Field
                          id="addCompany"
                          name="addCompany"
                          as="select"
                          required
                          className="form-select form-select-sm"
                          onChange={(e) => {
                            if (parseInt(e.target.value) === -1) {
                              setOtraEmpresa(true);
                            } else {
                              setOtraEmpresa(false);
                            }
                            handleChange(e);
                          }}
                        >
                          <option hidden selected>
                            Seleccione una empresa
                          </option>
                          {listCompany.map((item, index) => (
                            <option key={index} value={item.value}>
                              {item.desc}
                            </option>
                          ))}

                          <option value="-1">OTRA EMPRESA</option>
                        </Field>

                        {errors.addCompany && touched.addCompany && (
                          <span className="form__validation form__validation--error">
                            {errors.addCompany}
                          </span>
                        )}
                      </div>
                    </div>

                    {otraEmpresa && (
                      <div className="mb-4 form-group row">
                        <label
                          htmlFor="otraEmpresa"
                          className="col-sm-2 pe-0"
                        >
                          Escriba el nombre de la empresa
                        </label>
                        <div className="col-sm-10">
                          <Field
                            type="text"
                            name="otraEmpresa"
                            id="otraEmpresa"
                            className="form-control"
                            required
                          ></Field>

                          {errors.otraEmpresa && touched.otraEmpresa && (
                            <span className="form__validation form__validation--error">
                              {errors.otraEmpresa}
                            </span>
                          )}
                        </div>
                      </div>
                    )}

                    <div className="mb-4 row">
                      <label htmlFor="empresa" className="col-sm-2 pe-0">
                        Area
                      </label>
                      <div className="col-sm-10">
                        <Field
                          as="select"
                          name="areaId"
                          id="areaId"
                          required
                          className="form-control form-control-sm"
                        >
                          <option hidden selected>
                            Seleccione un area
                          </option>
                          {areaList.map((item) => {
                            return (
                              <option key={item.areaId} value={item.areaId}>
                                {item.nombre}
                              </option>
                            );
                          })}
                        </Field>
                        {errors.areaId && touched.areaId && (
                          <span className="form__validation form__validation--error">
                            {errors.areaId}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="mb-4 row">
                      <label
                        htmlFor="fecha-inicio"
                        className="col-sm-2 pe-0"
                      >
                        Fecha de Inicio
                      </label>
                      <div className="col-sm-5">
                        <Field
                          as="select"
                          name="mesInicio"
                          id="mesInicioAdd"
                          required
                          className="form-select form-select-sm"
                        >
                          {mesArr.map((item, index) => {
                            return (
                              <option key={index} value={item.value}>
                                {months[item.desc]}
                              </option>
                            );
                          })}
                        </Field>
                        {errors.mesInicio && touched.mesInicio && (
                          <span className="form__validation form__validation--error">
                            {errors.mesInicio}
                          </span>
                        )}
                      </div>
                      <div className="col-sm-5">
                        <Field
                          as="select"
                          name="anoInicio"
                          id="anoInicioAdd"
                          required
                          className="form-select form-select-sm"
                        >
                          {yearArr.map((item, index) => {
                            return (
                              <option key={index} value={item.value}>
                                {item.desc}
                              </option>
                            );
                          })}
                        </Field>
                        {errors.anoInicio && touched.anoInicio && (
                          <span className="form__validation form__validation--error">
                            {errors.anoInicio}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="mb-4 row justify-content-end">
                      <div className="col-sm-10">
                        <Field
                          type="checkbox"
                          name="currentJob"
                          id="currentJob"
                          checked={actualJob}
                          onClick={inHabilitarFechaFin}
                        ></Field>
                        <label
                          className="form-check-label"
                          htmlFor="job-status"
                        >
                          Actualmente tengo este empleo
                        </label>
                      </div>
                    </div>
                    <div className="mb-4 row">
                      <label htmlFor="fecha-fin" className="col-sm-2 pe-0">
                        Fecha de Fin
                      </label>
                      <div className="col-sm-5">
                        <Field
                          disabled={actualJob}
                          as="select"
                          name="mesFin"
                          id="mesFinAdd"
                          className="form-select form-select-sm"
                          required
                        >
                          {" "}
                          {mesArr.map((item, index) => {
                            return (
                              <option key={index} value={item.value}>
                                {months[item.desc]}
                              </option>
                            );
                          })}
                        </Field>
                        {errors.mesFin && touched.mesFin && (
                          <span className="form__validation form__validation--error">
                            {errors.mesFin}
                          </span>
                        )}
                      </div>
                      <div className="col-sm-5">
                        <Field
                          disabled={actualJob}
                          as="select"
                          name="anoFin"
                          id="anoFinAdd"
                          placeholder="Año"
                          className="form-select form-select-sm"
                          required
                        >
                          {yearArr.map((item, index) => {
                            return (
                              <option key={index} value={item.value}>
                                {item.desc}
                              </option>
                            );
                          })}
                        </Field>
                        {errors.anoFin && touched.anoFin && (
                          <span className="form__validation form__validation--error">
                            {errors.anoFin}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="mb-4 row">
                      <label
                        htmlFor="fecha-inicio"
                        className="col-sm-2 pe-0"
                      >
                        Descripcion
                      </label>
                      <div className="col-sm-10">
                        <Field
                          as="textarea"
                          name="description"
                          rows="4"
                          cols="50"
                        ></Field>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        data-bs-dismiss="modal"
                        className="btn btn--cancel"
                        onClick={() => setactualJob(false)}
                      >
                        Cancelar
                      </button>
                      <button
                        disabled={isSubmitting}
                        type="submit"
                        className="btn btn--small btn--purple"
                      >
                        <i className="fas fa-paper-plane"></i>Aceptar
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

function ModalEdit({setactualJob, expUpdate, UpdateExperiencia, Validaciones, showOtraEmprea, listCompany, areaList, mesArr, yearArr, actualJob, inHabilitarFechaFin, modalDelete, otraEmpresa, setOtraEmpresa}) {

  return (
    <>
      <div
        id="editar-experiencia-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>

              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
                onClick={() => setactualJob(false)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="form form--white">
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    position: expUpdate?.position ?? "",
                    company: expUpdate?.nameCompany ?? "",
                    description: expUpdate?.description ?? "",
                    mesInicio: expUpdate
                      ? parseInt(expUpdate.dateInit.substring(5, 7))
                      : 1,
                    anoInicio: expUpdate
                      ? expUpdate.dateInit.substring(0, 4)
                      : 2021,
                    mesFin: expUpdate
                      ? parseInt(expUpdate.dateEnd.substring(5, 7))
                      : 1,
                    anoFin: expUpdate
                      ? expUpdate.dateEnd.substring(0, 4)
                      : 2021,
                    currentJob: expUpdate?.currentlyJob ?? false,
                    areaId: expUpdate?.areaId ?? 1,
                    companyId: expUpdate?.companyId ?? "-1",
                    otraEmpresa: (expUpdate?.companyId === null) ? expUpdate.nameCompany : ""
                  }}
                  onSubmit={(values, { setSubmitting, resetForm }) => {
                    setSubmitting(true);
                    UpdateExperiencia(values);
                    resetForm(true);
                    setSubmitting(false);
                  }}
                  validationSchema={Validaciones}
                >
                  {({ errors, touched, isSubmitting, handleChange }) => (
                    <Form>
                      <div className="div__wrapper">
                        <div className="form__title text-center">
                          Actualizar Experiencia
                        </div>
                        <div className="form__description text-center">
                          Formulario de Prueba de actualizacion Experiencia
                          Usuario.
                        </div>
                        <div className="form__row">

                          <div className="col-sm-12 mb-3">
                            <label htmlFor="position">Cargo</label>
                            <Field
                              id="position"
                              name="position"
                              type="text"
                              // value={expUpdate.position}
                              required
                            ></Field>
                            {errors.position && touched.position && (
                              <span className="form__validation form__validation--error">
                                {errors.position}
                              </span>
                            )}
                          </div>

                          <div className="col-sm-12 mb-3">
                            <label htmlFor="company">Empresa</label>
                            <Field 
                              id="addCompanyEdit"
                              required
                              name="companyId"
                              as="select"
                              className="form-select form-select-sm"
                              onChange={(e) => {
                                if (parseInt(e.target.value) === -1) {
                                  setOtraEmpresa(true);
                                } else {
                                  setOtraEmpresa(false);
                                }
                                handleChange(e);
                              }}
                            >
                              <option hidden selected> Seleccione una empresa</option>
                              {listCompany.map((item, index) => (
                                <option key={index} value={item.value}>
                                  {item.desc}
                                </option>
                              ))}
                              <option value="-1">OTRA EMPRESA</option>
                            </Field>
                            <input
                              id="addOtraEmpresaEdit"
                              type="text"
                              className="form-control form-control-sm"
                              style={{ display: "none" }}
                            ></input>
                          </div>

                          {otraEmpresa && (
                            <div className="mb-4 form-group">
                              <label
                                htmlFor="otraEmpresa"
                              >
                                Escriba el nombre de la empresa
                              </label>
                                <Field
                                  type="text"
                                  name="otraEmpresa"
                                  id="otraEmpresa"
                                  className="form-control"
                                  required
                                ></Field>

                                {errors.otraEmpresa && touched.otraEmpresa && (
                                  <span className="form__validation form__validation--error">
                                    {errors.otraEmpresa}
                                  </span>
                                )}
                            </div>
                          )}

                          <div className="col-sm-12">
                            <label
                              htmlFor="empresa"
                              className="col-sm-2 pe-0"
                            >
                              Area
                            </label>
                            <Field
                              as="select"
                              name="areaId"
                              id="areaId"
                              className="form-select form-select-sm"
                              required
                            >
                              <option selected>Seleccione un area</option>
                              {areaList.map((item) => {
                                return (
                                  <option
                                    key={item.areaId}
                                    value={item.areaId}
                                  >
                                    {item.nombre}
                                  </option>
                                );
                              })}
                            </Field>
                          </div>
                        </div>
                        <div className="form__row">
                          <div className="col-sm-12">
                            <label htmlFor="mesInicio">Fecha Inicio</label>
                            <Field
                              as="select"
                              name="mesInicio"
                              id="mesInicioEdit"
                              required
                              placeholder="Mes"
                            >
                              {mesArr.map((item, index) => {
                                return (
                                  <option key={index} value={item.value}>
                                    {months[item.desc]}
                                  </option>
                                );
                              })}
                            </Field>
                            {errors.mesInicio && touched.mesInicio && (
                              <span className="form__validation form__validation--error">
                                {errors.mesInicio}
                              </span>
                            )}
                            <Field
                              as="select"
                              name="anoInicio"
                              id="anoInicioEdit"
                              required
                              placeholder="Año"
                            >
                              {yearArr.map((item, index) => {
                                return (
                                  <option key={index} value={item.value}>
                                    {item.desc}
                                  </option>
                                );
                              })}
                            </Field>
                            {errors.anoInicio && touched.anoInicio && (
                              <span className="form__validation form__validation--error">
                                {errors.anoInicio}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="mb-4 row justify-content-end">
                          <div
                            className="col-sm-12"
                            style={{ display: "inherit" }}
                          >
                            <Field
                              type="checkbox"
                              name="currentJob"
                              id="currentJob"
                              checked={actualJob}
                              onClick={inHabilitarFechaFin}
                            ></Field>
                            <label
                              className="form-check-label"
                              htmlFor="job-status"
                              style={{ marginLeft: "5px" }}
                            >
                              Actualmente tengo este empleo
                            </label>
                          </div>
                        </div>
                        <div className="form__row">
                          <div className="col-sm-12">
                            <label htmlFor="FechaFin">Fecha Fin</label>
                            <Field
                              disabled={actualJob}
                              as="select"
                              name="mesFin"
                              id="mesFinEdit"
                              placeholder="Mes"
                              className="form-select form-select-sm"
                              required
                            >
                              {mesArr.map((item, index) => {
                                return (
                                  <option key={index} value={item.value}>
                                    {months[item.desc]}
                                  </option>
                                );
                              })}
                            </Field>
                            {errors.mesFin && touched.mesFin && (
                              <span className="form__validation form__validation--error">
                                {errors.mesFin}
                              </span>
                            )}
                            <Field
                              disabled={actualJob}
                              as="select"
                              name="anoFin"
                              id="anoFinEdit"
                              placeholder="Año"
                              className="form-select form-select-sm"
                              required
                            >
                              {yearArr.map((item, index) => {
                                return (
                                  <option key={index} value={item.value}>
                                    {item.desc}
                                  </option>
                                );
                              })}
                            </Field>
                            {errors.anoFin && touched.anoFin && (
                              <span className="form__validation form__validation--error">
                                {errors.anoFin}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-sm-12">
                          <label htmlFor="description">Descripcion</label>
                          <div className="col-sm-12">
                            <Field
                              as="textarea"
                              name="description"
                              rows="4"
                              cols="50"
                            ></Field>
                          </div>
                        </div>
                        <div className="form__row">
                          <button
                            disabled={isSubmitting}
                            type="submit"
                            className="btn btn--gradient btn__icon btn__icon--door"
                          >
                            <i className="fas fa-paper-plane"></i>Aceptar
                          </button>
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={() => modalDelete()}
                          >
                            Eliminar
                          </button>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default Experiencia;
